import { CalcStorageDaysService } from './../../services/calc-storage-days.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormSec002 } from 'src/app/entity/forms/form-sec002';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Sec002CardIComponent } from './partialViews/sec002-card-I.component';
import { Sec002CardIIComponent } from './partialViews/sec002-card-II.component';
import { Sec002CardIIIComponent } from './partialViews/sec002-card-III.component';
import { Sec002CardIVComponent } from './partialViews/sec002-card-IV.component';
import { Sec002CardIXComponent } from './partialViews/sec002-card-IX.component';
import { Sec002CardVComponent } from './partialViews/sec002-card-V.component';
import { Sec002CardVIComponent } from './partialViews/sec002-card-VI.component';
import { Sec002CardVIIComponent } from './partialViews/sec002-card-VII.component';
import { Sec002CardVIIIComponent } from './partialViews/sec002-card-VIII.component';
import { Sec002CardXComponent } from './partialViews/sec002-card-X.component';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { CardSdcComponent } from 'src/app/shared/card-sdc-despalha/sdc-card.component';
import { SdcDescargaItem } from 'src/app/entity/models/sdc-descarga-item';

import { LoteDsItem } from 'src/app/entity/models/lote-ds-itens';
import { Store } from '@ngrx/store';
import Add from 'src/app/action/type.action';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import * as moment from 'moment';
import { Sec002SecagemItem } from 'src/app/entity/models/sec-002-secagem-item';
import { element } from 'protractor';

@Component({
  selector: 'app-form-sec002',
  templateUrl: './form-sec002.component.html',
  styleUrls: ['./form-sec002.component.scss']
})

export class FormSec002Component implements OnInit, AfterViewInit {
  [x: string]: any;
  public areaSelect: string = localStorage.getItem('area-select') || null;
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public formSec002: FormSec002 = new FormSec002();
  public disablesave: boolean = false;
  valuesInitial: any;
  valoresAlterados: any[] = [];
  totalDSItems: number = 0;
  get isComercial() {
    return this.areaSelect.includes('Comercial');
  }

  get isBasica() {
    return this.areaSelect.includes('Básica') && !this.areaSelect.includes("Pré")
  }

  get isPreBasica() {
    return this.areaSelect.includes("Pré-Básica")
  }

  @ViewChild(Sec002CardIComponent, { static: false }) sec002CardIComponent: Sec002CardIComponent;
  @ViewChild(Sec002CardIIComponent, { static: false }) sec002CardIIComponent: Sec002CardIIComponent;
  @ViewChild(Sec002CardIIIComponent, { static: false }) sec002CardIIIComponent: Sec002CardIIIComponent;
  @ViewChild(Sec002CardIVComponent, { static: false }) sec002CardIVComponent: Sec002CardIVComponent;
  @ViewChild(Sec002CardVComponent, { static: false }) sec002CardVComponent: Sec002CardVComponent;
  @ViewChild(Sec002CardVIComponent, { static: false }) sec002CardVIComponent: Sec002CardVIComponent;
  @ViewChild(Sec002CardVIIComponent, { static: false }) sec002CardVIIComponent: Sec002CardVIIComponent;
  @ViewChild(Sec002CardVIIIComponent, { static: false }) sec002CardVIIIComponent: Sec002CardVIIIComponent;
  @ViewChild(Sec002CardIXComponent, { static: false }) sec002CardIXComponent: Sec002CardIXComponent;
  @ViewChild(Sec002CardXComponent, { static: false }) sec002CardXComponent: Sec002CardXComponent;

  @ViewChild(CardSdcComponent, { static: false }) cardSdcComponent: CardSdcComponent;

  sec002$: Observable<[]>;

  isRessectSelected: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected calcStorageDaysService: CalcStorageDaysService,
    private add: Store<any>,
    protected resumeAllFormsService: ResumeAllFormsService,
    public dialog: MatDialog) {
    this.header = new CabecalhoDTO();
    this.formulario = this.formSec002.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(data => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormSec002, EnumFormType.Edit);
            if (this.sec002CardIComponent.isPreBasica) {
              this.sec002CardIComponent.isEdit = true;
            }
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormSec002, EnumFormType.Details);
          }
          this.updateForm(data);
        } else {
          this.header = this.generalService.createHeader(EnumForm.FormSec002, EnumFormType.New);
          this.getUser();
        }
      }
    });
  }

  ngOnInit(): void {
    this.header = this.generalService.createHeader(EnumForm.FormSec002, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);
    if (this.areaSelect.includes('Básica')) {
      this.initializeValues();
    }
  }


  private initializeValues(): void {
    this.sec002CardVComponent.formulario.get('Concentracao_k_obiol').setValue(2);
    this.sec002CardVComponent.formulario.get('Concentracao_actellic').setValue(1.6);
  }

  getValue() {
    const get = localStorage.getItem('Ressect');
    if (get === 'SIM') {
      this.isRessectSelected = true;
    }

  }
  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;
    this.calcLocalAtual();
    if (this.validFormsToSave() === '') {
      this.buildFormulario();
      if (this.areaSelect.includes('Pré-Básica')) {
        this.buildListSecagem(id);
      }
      else {
        this.buildListSdcDespalha();
        this.buildListLoteDS();
      }
      this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'sec002_agg');
      // CHAMAR MODAL DE CONFIRMACAO
      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
    }
  }

  public openConfirmDialog(valoresAlterados: any[], isAddFlow): void {

    const values: any[] = valoresAlterados;

    const dialogRef = this.dialog.open(FormModalConfirmComponent, {

      data: {
        valoresAlterados: values,
        isAddFlow
      }

    });

    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'sec002', 'formsec002');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    })
  }

  getForms(): FormGroup[] {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.sec002CardIComponent.formulario);
    arrForms.push(this.sec002CardIIComponent.formulario);
    arrForms.push(this.sec002CardIIIComponent.formulario);
    arrForms.push(this.sec002CardIVComponent.formulario);
    arrForms.push(this.sec002CardVComponent.formulario);
    arrForms.push(this.sec002CardVIComponent.formulario);
    arrForms.push(this.sec002CardVIIComponent.formulario);
    arrForms.push(this.sec002CardVIIIComponent.formulario);
    arrForms.push(this.sec002CardIXComponent.formulario);
    arrForms.push(this.sec002CardXComponent.formulario);
    return arrForms;
  }

  validFormsToSave(): string {
    if (this.areaSelect.includes('Pré-Básica')) {
      if (this.sec002CardIIComponent.secagemItemReferences.find(element => !element.instance.formulario?.valid)) {
        this.notificationService.sendNotification('', TypeMessage.FormValid, ActionMessage.Info);
        this.formulario.markAllAsTouched();
        return 'Erro';
      }
      else
        return this.formularioService.validForm(this.getForms());
    }
    else {
      return this.formularioService.validForm(this.getForms());
    }
  }

  cleanAll(): void {
    this.formularioService.cleanForm(this.getForms());
  }

  collapseAll(): void {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.sec002CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardIVComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardVComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardVIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardVIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardVIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardIXComponent.collapseCard = this.btnCollapse ? false : true;
    this.sec002CardXComponent.collapseCard = this.btnCollapse ? false : true;
    this.cardSdcComponent.collapseCard = this.btnCollapse ? false : true;

  }

  public buildFormulario(): void {
    this.formulario = this.formSec002.buildForm(this.formulario, this.getForms(), this.generalService);
  }

  public updateForm(data?: any): void {

    this.formulario.get('id').setValue(data.formulario.id);
    this.formSec002.updateForm(data, this.getForms(), this.generalService);

    if (this.areaSelect.includes('Pré-Básica')) {
      this.PreBasicaQua007Data(null);
      this.createSecagemCardIItemCompoment(data);
      this.sec002CardIComponent.changeHouveTroca();
      this.sec002CardIComponent.disableNumeroCampo = true;
      this.sec002CardIComponent.safraBasicaOld = data.formulario.safra_basica;
    }
    else {
      this.createSdcCardItemComponent(data);
      this.createAllLoteDSItemComponents(data);
      this.calcMotvEsperaDebulha(data.formulario.motivo_espera_debulha, true);
      this.calcRessecagem();
    }

    if (!this.areaSelect.includes('Básica')) {
      this.calcArmazemDias();
    }
  }

  // INICIO DO CODIGO DE CALCULO
  public async makeCalculations(event?: any): Promise<void> {
    this.calcRessecagem();
    if (this.sec002CardIIComponent.formulario.get('Ressecagem')?.value == 'SIM') {
      console.log('aqui');
      this.validateChronologicalOrder([
        { dataField: 'Inicio_enchimento_data', horaField: 'Inicio_enchimento_hora', alias: 'Início Enchimento Data e Hora' },
        { dataField: 'Termino_enchimento_data', horaField: 'Termino_enchimento_hora', alias: 'Término Enchimento Data e Hora' },
        { dataField: 'Inicio_secagem_data', horaField: 'Inicio_secagem_hora', alias: 'Início Secagem Data e Hora' },
        { dataField: 'Inversao_camara_data', horaField: 'Inversao_camara_hora', alias: 'Inversão Câmara Data e Hora' },
        { dataField: 'Termino_secagem_data', horaField: 'Termino_secagem_hora', alias: 'Término Secagem Data e Hora' },
        { dataField: 'Inicio_debulha_data', horaField: 'Inicio_debulha_hora', alias: 'Início Debulha Data e Hora' },
        { dataField: 'Inicio_ressecagem_data', horaField: 'Inicio_ressecagem_hora', alias: 'Início Ressecagem Data e Hora' },
        { dataField: 'Termino_ressecagem_data', horaField: 'Termino_ressecagem_hora', alias: 'Término Ressecagem Data e Hora' },
        { dataField: 'Termino_debulha_data', horaField: 'Termino_debulha_hora', alias: 'Término Debulha Data e Hora' },

      ]);
    } else {
      this.validateChronologicalOrder([
        { dataField: 'Inicio_enchimento_data', horaField: 'Inicio_enchimento_hora', alias: 'Início Enchimento Data e Hora' },
        { dataField: 'Termino_enchimento_data', horaField: 'Termino_enchimento_hora', alias: 'Término Enchimento Data e Hora' },
        { dataField: 'Inicio_secagem_data', horaField: 'Inicio_secagem_hora', alias: 'Início Secagem Data e Hora' },
        { dataField: 'Inversao_camara_data', horaField: 'Inversao_camara_hora', alias: 'Inversão Câmara Data e Hora' },
        { dataField: 'Termino_secagem_data', horaField: 'Termino_secagem_hora', alias: 'Término Secagem Data e Hora' },
        { dataField: 'Inicio_debulha_data', horaField: 'Inicio_debulha_hora', alias: 'Início Debulha Data e Hora' },
        { dataField: 'Termino_debulha_data', horaField: 'Termino_debulha_hora', alias: 'Término Debulha Data e Hora' },

      ]);
    }

    // this.validateRessecagemStart();
    this.enableMotvEsperaDebulha();
    this.calcEnchimentoAtv1010();
    this.calcPrimeiroCiclo();
    this.calcSegundoCiclo();
    this.calcRessecagemHoras();
    await this.calcSecagemAtv2010();
    this.calcEsperaHoras();
    // this.validateDebulhaEnd();
    this.calcDebulhaAtv3010();
    this.calcCaldaPorTonelada();
    this.calckObiol();
    this.calcActellic();
    this.calcArmazemDias();

    this.calcLocalAtual();
    this.calcSdcPesoRw();
    this.calcMediaUmidade();
    this.calcPesoDebulha();

  }

  private validateChronologicalOrder(dateTimePairs: { dataField: string, horaField: string, alias: string }[]): void {
    for (let i = 1; i < dateTimePairs.length; i++) {
      const previous = this.getDateTimeValue(dateTimePairs[i - 1].dataField, dateTimePairs[i - 1].horaField);
      const current = this.getDateTimeValue(dateTimePairs[i].dataField, dateTimePairs[i].horaField);
      previous.time = dateTimePairs[i - 1].horaField == null ? '0000' : previous.time
      if (dateTimePairs[i].dataField == 'Dt_colheita') {
        continue
      }
      if (!current.date || !current.time) {
        return;
      }

      if (!this.generalService.isDateTimeBGreaterThanA(previous.date, previous.time, current.date, current.time)) {
        this.setFieldError(dateTimePairs[i].dataField, `Data/Hora de ${dateTimePairs[i].alias} não pode ser menor que ${dateTimePairs[i - 1].alias}`);
        return;
      } else {
        this.clearFieldError(dateTimePairs[i].dataField);
      }
    }
  }

  private getDateTimeValue(dataField: string, horaField: string): { date: string, time: string } {
    const date = this.getFormCard(dataField)?.get(dataField)?.value;
    const time = this.getFormCard(horaField)?.get(horaField)?.value;
    return { date, time };
  }

  private clearFieldError(field: string): void {
    this.getFormCard(field).get(field).setErrors(null);
    this.getFormCard(field).get(field)?.updateValueAndValidity();
    this.getFormCard(field).get(field)?.markAsTouched();
  }

  public getFormCard(control) {
    if (this.sec002CardIComponent.formulario?.contains(control) || this.sec002CardIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "1");
      return this.sec002CardIComponent.formulario
    }
    else if (this.sec002CardIIComponent.formulario?.contains(control) || this.sec002CardIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "2");
      return this.sec002CardIIComponent.formulario
    }
    else if (this.sec002CardIIIComponent.formulario?.contains(control) || this.sec002CardIIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "3");
      return this.sec002CardIIIComponent.formulario
    }
    else if (this.sec002CardIVComponent.formulario?.contains(control) || this.sec002CardIVComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "4");
      return this.sec002CardIVComponent.formulario
    }
    else if (this.sec002CardVComponent.formulario?.contains(control) || this.sec002CardVComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "5");
      return this.sec002CardVComponent.formulario
    }
    else if (this.sec002CardVIComponent.formulario?.contains(control) || this.sec002CardVIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "6");
      return this.sec002CardVIComponent.formulario
    }
    else if (this.sec002CardVIIComponent.formulario?.contains(control) || this.sec002CardVIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "7");
      return this.sec002CardVIIComponent.formulario
    }
    else if (this.sec002CardVIIIComponent.formulario?.contains(control) || this.sec002CardVIIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "8");
      return this.sec002CardVIIIComponent.formulario
    }
    else if (this.sec002CardIXComponent.formulario?.contains(control) || this.sec002CardIXComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "9");
      return this.sec002CardIXComponent.formulario
    }
    else if (this.sec002CardXComponent.formulario?.contains(control) || this.sec002CardXComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "10");
      return this.sec002CardXComponent.formulario
    }
    else {
      // console.log(control, "1 else");
      return this.sec002CardIComponent.formulario
    }



  }

  private setFieldError(field: string, message: string): void {
    this.notificationService.sendNotification(message, TypeMessage.Personalized, ActionMessage.Info);
    this.getFormCard(field).get(field).setErrors({ invalidDatas: true });
  }

  private enableMotvEsperaDebulha(): void {

    // tslint:disable-next-line: max-line-length
    const terminoSecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value;
    const terminoSecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_hora')?.value;
    const inicioDebulhaData: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.value;
    const inicioDebulhaHora: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_hora')?.value;
    const terminoRessecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_data')?.value;
    const terminoRessecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_hora')?.value;
    // this.ValidateSecagemHour();
    this.calcRessecagemHoras();
    // tslint:disable-next-line: max-line-length
    if (inicioDebulhaData?.length >= 8 && terminoRessecagemData?.length >= 8 && inicioDebulhaHora?.length > 0 && terminoRessecagemHora?.length > 0) {
      const inicioDebulha: Date = this.generalService.createDateTimeData(inicioDebulhaData, inicioDebulhaHora);
      const terminoRessecagem: Date = this.generalService.createDateTimeData(terminoRessecagemData, terminoRessecagemHora);
      // tslint:disable-next-line: max-line-length
      this.calcMotvEsperaDebulha(this.generalService.timeDiffCalc(terminoRessecagem, inicioDebulha), false);
    }
    else if (terminoSecagemData?.length >= 8 && inicioDebulhaData?.length >= 8 && terminoSecagemHora?.length > 0 && inicioDebulhaHora?.length > 0) {
      const inicioDebulha: Date = this.generalService.createDateTimeData(inicioDebulhaData, inicioDebulhaHora);
      const terminoSecagem: Date = this.generalService.createDateTimeData(terminoSecagemData, terminoSecagemHora);
      // tslint:disable-next-line: max-line-length
      this.calcMotvEsperaDebulha(this.generalService.timeDiffCalc(terminoSecagem, inicioDebulha), false);
    } else {
      this.calcMotvEsperaDebulha(0, false);
    }
  }

  private calcMotvEsperaDebulha(value: number, isUpdate: boolean): void {
    if (value > 15 && isUpdate === false) {
      this.sec002CardIIIComponent.readOnlyMtvEspDebulha = false;
      this.sec002CardIIIComponent.formulario.get('Motivo_espera_debulha').setValidators([Validators.required]);
    } else if (value > 15 && isUpdate === true) {
      this.sec002CardIIIComponent.readOnlyMtvEspDebulha = false;
      this.sec002CardIIIComponent.formulario.get('Motivo_espera_debulha').setValidators([Validators.required]);
    }
    else {
      this.sec002CardIIIComponent.readOnlyMtvEspDebulha = true;
      this.sec002CardIIIComponent.formulario.get('Motivo_espera_debulha').setValidators([]);
      this.sec002CardIIIComponent.formulario.get('Motivo_espera_debulha').setValue(null);

    }
    this.sec002CardIIIComponent.formulario.get('Motivo_espera_debulha').updateValueAndValidity();
  }

  private calcEnchimentoAtv1010(): void {

    // tslint:disable-next-line: max-line-length
    const inicioEnchimentoData: string = this.sec002CardIComponent.formulario.get('Inicio_enchimento_data')?.value;
    const inicioEnchimentoHora: string = this.sec002CardIComponent.formulario.get('Inicio_enchimento_hora')?.value;
    const terminoEnchimentoData: string = this.sec002CardIComponent.formulario.get('Termino_enchimento_data')?.value;
    const terminoEnchimentoHora: string = this.sec002CardIComponent.formulario.get('Termino_enchimento_hora')?.value;
    const rangeDateEnchimento: boolean = this.generalService.isValidRangeDate(inicioEnchimentoData, terminoEnchimentoData);
    const rangeHourEnchimento: boolean = this.generalService.isValidRangeHour(inicioEnchimentoHora, terminoEnchimentoHora, inicioEnchimentoData, terminoEnchimentoData);
    // if (rangeDateEnchimento === true) {

    //   this.sec002CardIComponent.formulario.get('Inicio_enchimento_data')?.setErrors({ Inicio_enchimento_data: true });
    //   this.sec002CardIComponent.formulario.get('Termino_enchimento_data').setErrors({ invalidData: true });
    // }

    // if (rangeHourEnchimento === true) {

    //   this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
    //   this.sec002CardIComponent.formulario.get('Termino_enchimento_hora')?.setErrors({ Termino_enchimento_hora: true });

    // }

    // tslint:disable-next-line: max-line-length
    if (inicioEnchimentoData?.length >= 8 && terminoEnchimentoData?.length >= 8 && inicioEnchimentoHora?.length > 0 && terminoEnchimentoHora?.length > 0) {
      const inicioEnchimento: Date = this.generalService.createDateTimeData(inicioEnchimentoData, inicioEnchimentoHora);
      const terminoEnchimento: Date = this.generalService.createDateTimeData(terminoEnchimentoData, terminoEnchimentoHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Enchimento_horas_atividade_1010').setValue(this.generalService.timeDiffCalc(terminoEnchimento, inicioEnchimento));
    } else {
      this.sec002CardIVComponent.formulario.get('Enchimento_horas_atividade_1010').setValue(0);
    }
  }

  private calcPrimeiroCiclo(): void {
    // tslint:disable-next-line: max-line-length
    const inicioSecagemData: string = this.sec002CardIIComponent.formulario.get('Inicio_secagem_data')?.value;
    const inicioSecagemHora: string = this.sec002CardIIComponent.formulario.get('Inicio_secagem_hora')?.value;
    const inversaoCamaraData: string = this.sec002CardIIComponent.formulario.get('Inversao_camara_data')?.value;
    const inversaoCamaraHora: string = this.sec002CardIIComponent.formulario.get('Inversao_camara_hora')?.value;
    // this.ValidateSecagemDate();
    // tslint:disable-next-line: max-line-length
    if (inicioSecagemData?.length >= 8 && inversaoCamaraData?.length >= 8 && inicioSecagemHora?.length > 0 && inversaoCamaraHora?.length > 0) {
      const inicioSecagem: Date = this.generalService.createDateTimeData(inicioSecagemData, inicioSecagemHora);
      const inversaoCamara: Date = this.generalService.createDateTimeData(inversaoCamaraData, inversaoCamaraHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Primeiro_ciclo_horas').setValue(this.generalService.timeDiffCalc(inicioSecagem, inversaoCamara));
    } else {
      this.sec002CardIVComponent.formulario.get('Primeiro_ciclo_horas').setValue(0);
    }
  }

  // private ValidateSecagemDate() {
  //   const terminoEnchimentoData = moment(this.sec002CardIComponent.formulario.get('Inicio_enchimento_data')?.value as string, 'DD/MM/YYYY hh:mm:ss');
  //   const inicioSecagemData = moment(this.sec002CardIIComponent.formulario.get('Inicio_secagem_data')?.value as string, 'DD/MM/YYYY hh:mm:ss');
  //   const terminoSecagemData = moment(this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value as string, 'DD/MM/YYYY hh:mm:ss');
  //   const inversaoCamara = moment(this.sec002CardIIComponent.formulario.get('Inversao_camara_data')?.value as string, 'DD/MM/YYYY hh:mm:ss')
  //   // const terminoSecagem =  moment (this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value as string, 'DD/MM/YYYY hh:mm:ss')
  //   // const inicioDebulha = moment (this.sec002CardIIComponent.formulario.get('Inicio_debulha_data')?.value as string, 'DD/MM/YYYY hh:mm:ss')
  //   // const terminoDebulha = moment (this.sec002CardIIComponent.formulario.get('Termino_debulha_data')?.value as string, 'DD/MM/YYYY hh:mm:ss')
  //   if (inicioSecagemData.isBefore(terminoEnchimentoData)) {
  //     this.sec002CardIIComponent.formulario.get('Inicio_secagem_data')?.setErrors({ invalidData: true });
  //   }
  //   if (inversaoCamara.isBefore(inicioSecagemData)) {
  //     this.sec002CardIIComponent.formulario.get('Inversao_camara_data')?.setErrors({ invalidData: true });
  //   }
  //   if (terminoSecagemData.isBefore(inversaoCamara)) {
  //     this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.setErrors({ invalidData: true });
  //   }
  // }



  // private ValidateSecagemHour() {

  //   const inicioSecagemHora: string = this.sec002CardIIComponent.formulario.get('Inicio_secagem_hora')?.value;
  //   const terminoSecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_hora')?.value;
  //   const inicioSecagemData: string = this.sec002CardIIComponent.formulario.get('Inicio_secagem_data')?.value;
  //   const terminoSecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value;
  //   const rangeHourSecagem: boolean = this.generalService.isValidRangeHour(inicioSecagemHora, terminoSecagemHora, inicioSecagemData, terminoSecagemData);

  //   if (rangeHourSecagem === true) {

  //     this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
  //     this.sec002CardIIComponent.formulario.get('Termino_secagem_hora')?.setErrors({ Termino_secagem_hora: true });
  //   }
  // }

  private calcSegundoCiclo(): void {
    // tslint:disable-next-line: max-line-length
    const terminoSecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value;
    const terminoSecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_hora')?.value;
    const inversaoCamaraData: string = this.sec002CardIIComponent.formulario.get('Inversao_camara_data')?.value;
    const inversaoCamaraHora: string = this.sec002CardIIComponent.formulario.get('Inversao_camara_hora')?.value;
    // this.ValidateSecagemDate();
    // this.ValidateSecagemHour();
    // tslint:disable-next-line: max-line-length
    if (terminoSecagemData?.length >= 8 && inversaoCamaraData?.length >= 8 && terminoSecagemHora?.length > 0 && inversaoCamaraHora?.length > 0) {
      const terminoSecagem: Date = this.generalService.createDateTimeData(terminoSecagemData, terminoSecagemHora);
      const inversaoCamara: Date = this.generalService.createDateTimeData(inversaoCamaraData, inversaoCamaraHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Segundo_ciclo_horas').setValue(this.generalService.timeDiffCalc(inversaoCamara, terminoSecagem));
    } else {
      this.sec002CardIVComponent.formulario.get('Segundo_ciclo_horas').setValue(0);
    }
  }

  private calcRessecagemHoras(): void {

    // tslint:disable-next-line: max-line-length
    const inicioRessecagemData: string = this.sec002CardIIComponent.formulario.get('Inicio_ressecagem_data')?.value;
    const inicioRessecagemHora: string = this.sec002CardIIComponent.formulario.get('Inicio_ressecagem_hora')?.value;
    const terminoRessecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_data')?.value;
    const terminoRessecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_hora')?.value;
    const rangeDateRessecagem: boolean = this.generalService.isValidRangeDate(inicioRessecagemData, terminoRessecagemData);
    const rangeHourRessecagem: boolean = this.generalService.isValidRangeHour(inicioRessecagemHora, terminoRessecagemHora, inicioRessecagemData, terminoRessecagemData);

    // if (rangeDateRessecagem === true) {

    //   this.notificationService.sendNotification('', TypeMessage.InvalidRangeDate, ActionMessage.Error);
    //   // this.sec002CardIIComponent.formulario.get('Inicio_ressecagem_data')?.setErrors({ Inicio_ressecagem_data: true });
    //   this.sec002CardIIComponent.formulario.get('Termino_ressecagem_data')?.setErrors({ Termino_ressecagem_data: true });
    // }

    // if (rangeHourRessecagem === true) {

    //   this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
    //   this.sec002CardIIComponent.formulario.get('Termino_ressecagem_data')?.setErrors({ invalidData: true });

    // }


    // tslint:disable-next-line: max-line-length
    if (inicioRessecagemData?.length >= 8 && terminoRessecagemData?.length >= 8 && inicioRessecagemHora?.length > 0 && terminoRessecagemHora?.length > 0) {
      const inicioRessecagem: Date = this.generalService.createDateTimeData(inicioRessecagemData, inicioRessecagemHora);
      const terminoRessecagem: Date = this.generalService.createDateTimeData(terminoRessecagemData, terminoRessecagemHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Ressecagem_horas').setValue(this.generalService.timeDiffCalc(terminoRessecagem, inicioRessecagem));
    } else {
      this.sec002CardIVComponent.formulario.get('Ressecagem_horas').setValue(0);
    }
  }

  private async calcSecagemAtv2010(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const primeiroCicloHoras: number = (this.sec002CardIVComponent.formulario.get('Primeiro_ciclo_horas')?.value);
    const segundoCicloHoras: number = (this.sec002CardIVComponent.formulario.get('Segundo_ciclo_horas')?.value);
    const ressecagemHoras: number = (this.sec002CardIVComponent.formulario.get('Ressecagem_horas')?.value);
    // tslint:disable-next-line: max-line-length
    this.sec002CardIVComponent.formulario.get('Secagem_horas_atividade_2010').setValue(primeiroCicloHoras + segundoCicloHoras + ressecagemHoras);
  }

  private calcEsperaHoras(): void {
    // tslint:disable-next-line: max-line-length
    const inicioDebulhaData: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.value;
    const inicioDebulhaHora: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_hora')?.value;
    const terminoSecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value;
    const terminoSecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_secagem_hora')?.value;
    const terminoRessecagemData: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_data')?.value;
    const terminoRessecagemHora: string = this.sec002CardIIComponent.formulario.get('Termino_ressecagem_hora')?.value;
    // tslint:disable-next-line: max-line-length
    if (inicioDebulhaData?.length >= 8 && terminoRessecagemData?.length >= 8 && inicioDebulhaHora?.length > 0 && terminoRessecagemHora?.length > 0) {
      const inicioDebulha: Date = this.generalService.createDateTimeData(inicioDebulhaData, inicioDebulhaHora);
      const terminoRessecagem: Date = this.generalService.createDateTimeData(terminoRessecagemData, terminoRessecagemHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Espera_horas').setValue(this.generalService.timeDiffCalc(terminoRessecagem, inicioDebulha));
    }
    else if (inicioDebulhaData?.length >= 8 && terminoSecagemData?.length >= 8 && inicioDebulhaHora?.length > 0 && terminoSecagemHora?.length > 0) {
      const inicioDebulha: Date = this.generalService.createDateTimeData(inicioDebulhaData, inicioDebulhaHora);
      const terminoSecagem: Date = this.generalService.createDateTimeData(terminoSecagemData, terminoSecagemHora);
      // tslint:disable-next-line: max-line-length
      this.sec002CardIVComponent.formulario.get('Espera_horas').setValue(this.generalService.timeDiffCalc(terminoSecagem, inicioDebulha));
    } else {
      this.sec002CardIVComponent.formulario.get('Espera_horas').setValue(0);
    }
  }

  private calcDebulhaAtv3010(): void {
    // Obtenção e formatação de datas e horas utilizando Moment.js
    const inicioDebulha = moment(
      `${this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.value} ${this.sec002CardIIIComponent.formulario.get('Inicio_debulha_hora')?.value}`,
      'DD/MM/YYYY HH:mm:ss'
    );
    const terminoDebulha = moment(
      `${this.sec002CardIIIComponent.formulario.get('Termino_debulha_data')?.value} ${this.sec002CardIIIComponent.formulario.get('Termino_debulha_hora')?.value}`,
      'DD/MM/YYYY HH:mm:ss'
    );
    const terminoSecagem = moment(
      this.sec002CardIIComponent.formulario.get('Termino_secagem_data')?.value as string,
      'DD/MM/YYYY HH:mm:ss'
    );

    // Obtenção de valores do formulário
    const inicioDebulhaData = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.value;
    const inicioDebulhaHora = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_hora')?.value;
    const terminoDebulhaData = this.sec002CardIIIComponent.formulario.get('Termino_debulha_data')?.value;
    const terminoDebulhaHora = this.sec002CardIIIComponent.formulario.get('Termino_debulha_hora')?.value;
    const ressecagemHoras = this.sec002CardIVComponent.formulario.get('Ressecagem_horas')?.value;

    // Validação de intervalos
    // const isRangeDateValid = this.generalService.isValidRangeDate(inicioDebulhaData, terminoDebulhaData);
    // const isRangeHourValid = this.generalService.isValidRangeHour(
    //     inicioDebulhaHora, 
    //     terminoDebulhaHora, 
    //     inicioDebulhaData, 
    //     terminoDebulhaData
    // );

    // Validações com erros configurados no formulário
    // if (inicioDebulha.isBefore(terminoSecagem)) {
    //     this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.setErrors({ invalidData: true });
    // }

    // if (terminoDebulha.isBefore(inicioDebulha)) {
    //     this.sec002CardIIIComponent.formulario.get('Termino_debulha_data')?.setErrors({ invalidData: true });
    // }

    // if (!isRangeHourValid) {
    //     this.sec002CardIIIComponent.formulario.get('Termino_debulha_hora')?.setErrors({ invalidData: true });
    // }

    // Cálculo da diferença em horas
    const debulhaHoras = terminoDebulha.diff(inicioDebulha, 'hours', true);

    let resultado = debulhaHoras;
    if (ressecagemHoras > 0) {
      if (debulhaHoras < ressecagemHoras) {
        this.sec002CardIIIComponent.formulario.get('Termino_debulha_hora')?.setErrors({ invalidDebulhaTime: true });
        resultado = 0;
      } else {
        resultado -= ressecagemHoras;
      }
    }

    // Ajuste do resultado para valor absoluto
    resultado = Math.abs(resultado);

    // Atualização do valor no formulário
    this.sec002CardIVComponent.formulario.get('Debulha_horas_atividade_3010')?.setValue(resultado);
  }


  calcDatePreBasica($event) {
    this.sec002CardIVComponent.formulario?.get('secagem_horas').setValue($event.sumHoursSecagem / 3600000);
    this.sec002CardIVComponent.formulario?.get('ressecagem_horas').setValue($event.sumHoursReSecagem / 3600000);

    var firstElement = this.sec002CardIIComponent.secagemItemReferences.find(() => true);

    if (firstElement) {
      var dateRecieve = new Date(this.sec002CardIVComponent.dataRecebimento);
      var splitDate = firstElement.instance.formulario?.get('amostragem_data_inicio').value.split('/');
      var splitHours = firstElement.instance.formulario?.get('amostragem_hora_inicio').value.split(':');
      var dateFirstSec = new Date(splitDate[2], splitDate[1] - 1, splitDate[0], splitHours[0], splitHours[1]);
      this.sec002CardIVComponent.formulario?.get('tempo_de_patio').setValue(Math.abs(dateRecieve.getTime() - dateFirstSec.getTime()) / 36e5);

      if (this.sec002CardIVComponent.formulario?.get('tempo_de_patio').value > 12.5)
        this.sec002CardVIIComponent.formulario?.get('faixa_azul_tempo_de_patio').setValue('SIM');
      else
        this.sec002CardVIIComponent.formulario?.get('faixa_azul_tempo_de_patio').setValue('NÃO');

      if (this.sec002CardIIComponent.secagemItemReferences.find(p => p.instance.formulario?.get('Ressecagem').value === 'SIM'))
        this.sec002CardVIIComponent.formulario?.get('Faixa_azul_ressecagem').setValue('SIM');
      else
        this.sec002CardVIIComponent.formulario?.get('Faixa_azul_ressecagem').setValue('NÃO');

    }

  }


  private calcCaldaPorTonelada(): void {

    let resultado = 0;
    // tslint:disable-next-line: max-line-length
    const pesoDebulhaKg: number = (this.sec002CardVComponent.formulario.get('peso_debulha_kg_total')?.value);
    const volumeCaldaLitro: number = (this.sec002CardVComponent.formulario.get('Volume_calda_litros')?.value);
    if (volumeCaldaLitro > 0 && pesoDebulhaKg > 0) {
      const peso = pesoDebulhaKg / 1000;
      if (peso > 0) {
        resultado = volumeCaldaLitro / peso;
      }
    }
    // tslint:disable-next-line: max-line-length
    this.sec002CardVComponent.formulario.get('Calda_por_tonelada_l_ton').setValue(resultado);
  }

  private calckObiol(): void {
    // tslint:disable-next-line: max-line-length
    const conckObiol: number = (this.sec002CardVComponent.formulario.get('Concentracao_k_obiol')?.value);
    const volumeCaldaLitro: number = (this.sec002CardVComponent.formulario.get('Volume_calda_litros')?.value);
    let resultado: number = (this.generalService.CalcLitros((volumeCaldaLitro * conckObiol), 1));
    // tslint:disable-next-line: max-line-length
    this.sec002CardVComponent.formulario.get('K_obiol_litros').setValue(resultado);
  }

  private calcActellic(): void {
    // tslint:disable-next-line: max-line-length
    const concActell: number = (this.sec002CardVComponent.formulario.get('Concentracao_actellic')?.value);
    const volumeCaldaLitro: number = (this.sec002CardVComponent.formulario.get('Volume_calda_litros')?.value);
    let resultado: number = (this.generalService.CalcLitros((volumeCaldaLitro * concActell), 1));
    // tslint:disable-next-line: max-line-length
    this.sec002CardVComponent.formulario.get('Actellic_litros').setValue(resultado);
  }

  private calcArmazemDias(): void {

    // tslint:disable-next-line: no-inferrable-types
    let resultado: number = 0;

    const inicioDescargaSiloData: string = this.sec002CardVIComponent.formulario.get('Inicio_descarga_silo_data')?.value;
    const inicioDescargaSiloHora: string = this.sec002CardVIComponent.formulario.get('Inicio_descarga_silo_hora')?.value;
    const inicioDebulhaData: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_data')?.value;
    const inicioDebulhaHora: string = this.sec002CardIIIComponent.formulario.get('Inicio_debulha_hora')?.value;
    const inicioRetiradaArmazemData: string = this.sec002CardVIComponent.formulario.get('Inicio_retirada_armazem_data')?.value;
    const inicioRetiradaArmazemHora: string = this.sec002CardVIComponent.formulario.get('Inicio_retirada_armazem_hora')?.value;
    const inicioRetornoSiloData: string = this.sec002CardVIComponent.formulario.get('Inicio_retorno_silo_data')?.value;
    const inicioRetornoSiloHora: string = this.sec002CardVIComponent.formulario.get('Inicio_retorno_silo_hora')?.value;

    resultado = this.calcStorageDaysService.calcStorageDaysService(
      inicioRetiradaArmazemData,
      inicioRetiradaArmazemHora,
      inicioDescargaSiloData,
      inicioDescargaSiloHora,
      inicioDebulhaData,
      inicioDebulhaHora,
      inicioRetornoSiloData,
      inicioRetornoSiloHora
    );

    if (resultado > 60) {
      this.notificationService.showNotification(`Quantidades de dias armazenagem superior a 60.`);
    }
    this.sec002CardVIComponent.formulario.get('Armazenagem_dias').setValue((resultado));
  }

  private calcRessecagem(): void {
    const inicioRessecagemData: string = this.sec002CardIIComponent.formulario.get('Inicio_ressecagem_data')?.value;
    this.sec002CardIIComponent.formulario.get('Ressecagem').setValue(inicioRessecagemData?.length >= 8 ? 'SIM' : 'NÃO');
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_ressecagem').setValue(inicioRessecagemData?.length >= 8 ? 'SIM' : 'NÃO');
  }

  public async getQua007Data(event?: any): Promise<void> {

    const siteRecebimento = this.sec002CardIComponent.formulario.get('Site_recebimento')?.value as string ?? '';
    const safra = this.sec002CardIComponent.formulario.get('Safra')?.value as string ?? '';
    const controleSecagem = this.sec002CardIComponent.formulario.get('Controle_secagem')?.value as string ?? '';
    if (!!siteRecebimento && siteRecebimento?.length >= 0 && !!safra && safra?.length >= 0 && !!controleSecagem && controleSecagem?.length >= 0) {
      await this.formularioService.getQua007DataToSec002(siteRecebimento, safra, controleSecagem).pipe(take(1)).toPromise().then(async (response: any) => {
        this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
        this.sec002CardIComponent.formulario.get('Contrato_campo').setValue(response?.data?.contrato_juridico);
        this.sec002CardIComponent.formulario.get('Tipo_colheita').setValue(response?.data?.tipo_colheita);
        this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem').setValue(response?.data?.hibrido_rnc);
        this.sec002CardIComponent.formulario.get('Secador_camara').setValue(response?.data?.secador_camara);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_campo').setValue(response?.data?.faixa_azul_campo);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_umidade_de_colheita').setValue(response?.data?.faixa_azul_umidade);

        // this.sec002CardVIIComponent.formulario.get('Faixa_azul_sem_vapor_ou_ventilacao').setValue(response?.data?.faixa_azul_sem_vapor_ou_ventilacao);
        // this.sec002CardVIIComponent.formulario.get('Faixa_azul_ressecagem').setValue(response?.data?.faixa_azul_ressecagem);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_transbordo').setValue(response?.data?.faixa_azul_transbordo);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_claro_temperatura_carga').setValue(response?.data?.faixa_azul_claro_temperatura_carga);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_claro_tempo_de_patio').setValue(response?.data?.faixa_azul_claro_tempo_de_patio);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_temperatura_carga').setValue(response?.data?.faixa_azul_escuro_temperatura_carga);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_tempo_de_patio').setValue(response?.data?.faixa_azul_escuro_tempo_de_patio);
        this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_granel_tempo_de_transporte').setValue(response?.data?.faixa_azul_escuro_granel_tempo_de_transporte);
        // this.sec002CardVIIComponent.formulario.get('Faixa_roxa').setValue(response?.data?.faixa_roxa);
        // this.sec002CardVIIComponent.formulario.get('Faixa_marrom').setValue(response?.data?.faixa_marrom);

        //await this.enableGeracao();
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes a combinação ${siteRecebimento} - ${safra} - ${controleSecagem}. Entre em contato com o Administrador.`);
      });
    }
  }

  public async PreBasicaQua007Data(event?: any): Promise<void> {

    const safra = this.sec002CardIComponent.formulario?.get('safra').value
    const cerarBasica = this.sec002CardIComponent.formulario?.get('cerar_basica').value
    const nCampoBasica = this.sec002CardIComponent.formulario?.get('n_de_campo_basica').value
    const nCaixa = this.sec002CardIComponent.formulario?.get('numero_caixa').value
    this.formularioService.getInfoFromQua007ToSec002(safra, nCampoBasica, nCaixa, cerarBasica).pipe(take(1)).toPromise().then((result: any) => {

      if (result.data) {
        this.sec002CardIComponent.formulario?.get('contrato_campo').setValue(result.data.contrato_juridico);
        this.sec002CardIComponent.formulario?.get('cooperante').setValue(result.data.cooperante);
        this.sec002CardIComponent.formulario?.get('geracao_basica').setValue(result.data.geracao);
        this.sec002CardIComponent.formulario?.get('hibrido_rnc_linhagem').setValue(result.data.hibrido_rnc);
        this.sec002CardIComponent.formulario?.get('lote_rw').setValue(result.data.lote_rw);

        this.sec002CardIComponent.formulario?.get('umidade_recebimento').setValue(result.data.umidade_recebimento);
        this.sec002CardIComponent.formulario?.get('gleba').setValue(result.data.gleba);
        this.sec002CardIComponent.formulario?.get('peso_rw_kg_total').setValue(result.data.peso_liquido);
        this.sec002CardIComponent.formulario?.get('nota_ardida').setValue(result.data.nota_ardida);

        this.sec002CardIIComponent.pesoTotalRW = result.data.peso_total_rw;

        this.sec002CardIComponent.formulario?.get('altura_camada_m').setValue(result.data.altura_camada);
        this.sec002CardIComponent.formulario?.get('controle_caixa').setValue(result.data.controle_caixa);

        this.sec002CardIVComponent.dataRecebimento = result.data.chegada_patio;

        this.sec002CardVIIComponent.formulario?.get('Faixa_azul_campo').setValue(result.data.faixa_azul_campo);
        this.sec002CardVIIComponent.formulario?.get('Faixa_azul_umidade_de_colheita').setValue(result.data.faixa_azul_umidade);
      }

    }).catch(e => {
      this.sec002CardIComponent.formulario?.get('contrato_campo').setValue(null);
      this.sec002CardIComponent.formulario?.get('cooperante').setValue(null);
      this.sec002CardIComponent.formulario?.get('geracao_basica').setValue(null);
      this.sec002CardIComponent.formulario?.get('hibrido_rnc_linhagem').setValue(null);
      this.sec002CardIComponent.formulario?.get('lote_rw').setValue(null);
      this.sec002CardIComponent.formulario?.get('peso_rw_kg_total').setValue(null);
      this.sec002CardIComponent.formulario?.get('umidade_recebimento').setValue(null);
      this.sec002CardIComponent.formulario?.get('gleba').setValue(null);

      this.sec002CardIIComponent.pesoTotalRW = 0;

      this.sec002CardIComponent.formulario?.get('altura_camada_m').setValue(null);

      this.sec002CardIComponent.formulario?.get('controle_secagem').setValue(null);

      this.sec002CardIComponent.formulario?.get('controle_caixa').setValue(null);


      this.sec002CardIVComponent.dataRecebimento = null;

      this.sec002CardVIIComponent.formulario?.get('Faixa_azul_campo').setValue(null);
      this.sec002CardVIIComponent.formulario?.get('Faixa_azul_umidade_de_colheita').setValue(null);
    });
    // this.formularioService.getGlebaFromQua007ByCerarAndSafra(safraBasica, cerarBasica).pipe(take(1)).toPromise().then((result: any) => {

    //   if (result.data) {

    //     this.sec002CardIComponent.formulario?.get('gleba').setValue(result.data.gleba);

    //   }

    // }).catch(e => {

    //   this.sec002CardIComponent.formulario?.get('gleba').setValue(null);


    // });
  }

  public calcLocalAtual(): void {
    let resultado: string = '';

    if (!this.isComercial) {
      return
    }
    const inicioDescargaSiloData: string = this.sec002CardVIComponent.formulario.get('Inicio_descarga_silo_data')?.value;
    const inicioDescargaSiloHora: string = this.sec002CardVIComponent.formulario.get('Inicio_descarga_silo_hora')?.value;
    const inicioRetiradaArmazemData: string = this.sec002CardVIComponent.formulario.get('Inicio_retirada_armazem_data')?.value;
    const inicioRetiradaArmazemHora: string = this.sec002CardVIComponent.formulario.get('Inicio_retirada_armazem_hora')?.value;
    const inicioRetornoSiloData: string = this.sec002CardVIComponent.formulario.get('Inicio_retorno_silo_data')?.value;
    const inicioRetornoSiloHora: string = this.sec002CardVIComponent.formulario.get('Inicio_retorno_silo_hora')?.value;
    const inicioTransilagemData: string = this.sec002CardVIComponent.formulario.get('Inicio_transilagem_data')?.value;
    const inicioTransilagemHora: string = this.sec002CardVIComponent.formulario.get('Inicio_transilagem_hora')?.value;

    const siloDestinoTransilagem = this.sec002CardVIComponent.formulario.get('Silo_destino_transilagem')?.value as string ?? '';
    const siloDestinoRetorno = this.sec002CardVIComponent.formulario.get('Silo_destino_retorno')?.value as string ?? '';

    const isOkRetArm: boolean = this.generalService.isValidDate(inicioRetiradaArmazemData, inicioRetiradaArmazemHora);
    const isOkTransilagem: boolean = this.generalService.isValidDate(inicioTransilagemData, inicioTransilagemHora);
    const isOkDescSilo: boolean = this.generalService.isValidDate(inicioDescargaSiloData, inicioDescargaSiloHora);
    const isOkRetSilo: boolean = this.generalService.isValidDate(inicioRetornoSiloData, inicioRetornoSiloHora);

    const dtTransilagem: Date = this.generalService.createDateTimeData(inicioTransilagemData, inicioTransilagemHora);
    const dtRetArm: Date = this.generalService.createDateTimeData(inicioRetiradaArmazemData, inicioRetiradaArmazemHora);
    const dtDescSilo: Date = this.generalService.createDateTimeData(inicioDescargaSiloData, inicioDescargaSiloHora);
    const dtRetSilo: Date = this.generalService.createDateTimeData(inicioRetornoSiloData, inicioRetornoSiloHora);

    if (isOkTransilagem === false && isOkRetArm === false && isOkRetSilo === false && isOkDescSilo === false) {
      resultado = this.getSiloDestinoFromTheFirstLoteDS();
    }
    else if (isOkTransilagem === true && isOkRetArm === false && isOkRetSilo === false && isOkDescSilo === false) {
      resultado = siloDestinoTransilagem
    }
    else if (isOkTransilagem === true && ((dtRetArm > dtTransilagem === true)) && isOkRetSilo === false && isOkDescSilo === false) {
      resultado = 'Armazém';
    }
    else if (isOkTransilagem === false && ((dtRetArm > dtTransilagem === true) || (dtTransilagem === undefined)) && isOkRetSilo === false && isOkDescSilo === false) {
      resultado = 'Armazém';
    }
    else if (isOkTransilagem === true && ((dtRetArm > dtTransilagem === true)) && isOkRetSilo === true && isOkDescSilo === false) {
      resultado = siloDestinoRetorno
    }
    else if (isOkTransilagem === false && ((dtRetArm > dtTransilagem === true) || (dtTransilagem === undefined)) && isOkRetSilo === true && isOkDescSilo === false) {
      resultado = siloDestinoRetorno;
    }
    else if (isOkDescSilo === true) {
      resultado = 'Consumido';
    }
    this.sec002CardVIComponent.formulario.get('Local_atual').setValue(resultado);
  }

  private enableGeracao(): void {
    const site_recebimento: string = this.sec002CardIComponent.formulario.get('Site_recebimento')?.value?.toUpperCase() ?? '';
    const site_origem: string = this.sec002CardIComponent.formulario.get('Site_origem')?.value?.toUpperCase() ?? '';
    if (site_origem !== 'CDR' && site_recebimento === 'PTU-BÁSICA') {
      this.sec002CardIComponent.isReadyOnly = false;
    } else if (site_origem === 'CDR' && site_recebimento !== 'PTU-BÁSICA') {
      this.sec002CardIComponent.isReadyOnly = false;
    } else if (site_origem === 'CDR' && site_recebimento === 'PTU-BÁSICA') {
      this.sec002CardIComponent.isReadyOnly = false;
    } else {
      this.sec002CardIComponent.isReadyOnly = true;
      this.sec002CardIComponent.formulario.get('Geracao').reset();
      this.sec002CardIComponent.formulario.get('Especie').reset();
      this.sec002CardIComponent.formulario.get('Num_campo').reset();
    }
  }


  public createAllLoteDSItemComponents(data: any): void {
    if (!!data.formulario?.list_loteds) {
      this.totalDSItems = data.formulario.list_loteds?.length > 0 ?
        data.formulario.list_loteds?.length > this.sec002CardVComponent.maxItensOnList ?
          this.LoteDsItemComponent.maxItensOnList :
          data.formulario.list_loteds?.length :
        this.LoteDsItemComponent.minItensOnList;

      for (let j = 0; j < this.totalDSItems; j++) {
        this.sec002CardVComponent.createLoteDsItemComponent();
      }

      if (this.sec002CardVComponent.VCR.length < 1) return;

      for (let key = 0; key < this.totalDSItems; key++) {
        let componentRef = this.sec002CardVComponent.lotesDsItemsReferences.filter(x => x.instance.unique_key == key)[0];
        componentRef.instance.btnExcluir = true;
        componentRef.instance.formulario.get('id').setValue(data.formulario.list_loteds[key].id);
        componentRef.instance.formulario.get('Peso_debulha_kg').setValue(data.formulario.list_loteds[key].peso_debulha_kg);
        componentRef.instance.formulario.get('Lote_ds').setValue(data.formulario.list_loteds[key].lote_ds);
        componentRef.instance.formulario.get('Silo_destino').setValue(data.formulario.list_loteds[key].silo_destino);
      }
    }
  }


  private getSiloDestinoFromTheFirstLoteDS(): string {
    let componentRef = this.sec002CardVComponent.lotesDsItemsReferences.filter(x => x.instance.unique_key == 0)[0];
    return !!componentRef ? componentRef.instance.formulario.get('Silo_destino').value : "";
  }

  public buildListLoteDS() {
    const loteDS: LoteDsItem[] = [];
    this.sec002CardVComponent.lotesDsItemsReferences.forEach((x) => {
      if (x.instance.formulario.get('Peso_debulha_kg').value !== null) {
        // &&
        // x.instance.formulario.get('Lote_ds')?.value !== null &&
        // x.instance.formulario.get('Silo_destino')?.value !== null){
        loteDS.push({
          id: x.instance.formulario.get('id')?.value,
          peso_debulha_kg: x.instance.formulario.get('Peso_debulha_kg')?.value,
          lote_ds: x.instance.formulario.get('Lote_ds')?.value,
          silo_destino: x.instance.formulario.get('Silo_destino')?.value
        })
      }

    });
    this.formulario.get('list_loteds').setValue(loteDS);
  }


  private buildListSecagem(sec_id: number): void {
    const secagemList: Sec002SecagemItem[] = [];
    this.sec002CardIIComponent.secagemItemReferences.forEach(element => {
      secagemList.push({
        id: element.instance.formulario?.get('id').value,
        sec002_id: sec_id,
        amostra_1_umidade: element.instance.formulario?.get('amostra_1_umidade').value,
        amostra_2_umidade: element.instance.formulario?.get('amostra_2_umidade').value,
        amostra_3_umidade: element.instance.formulario?.get('amostra_3_umidade').value,
        amostragem_data_fim: element.instance.formulario?.get('amostragem_data_fim').value,
        amostragem_data_inicio: element.instance.formulario?.get('amostragem_data_inicio').value,
        amostragem_hora_fim: element.instance.formulario?.get('amostragem_hora_fim').value,
        amostragem_hora_inicio: element.instance.formulario?.get('amostragem_hora_inicio').value,
        andar_secador: element.instance.formulario?.get('andar_secador').value,
        finalizou_secagem_caixa: element.instance.formulario?.get('finalizou_secagem_caixa').value,
        numero_dumper: element.instance.formulario?.get('numero_dumper').value,
        numero_secador: element.instance.formulario?.get('numero_secador').value,
        peso_pos_secagem: element.instance.formulario?.get('peso_pos_secagem').value,
        ressecagem: element.instance.formulario?.get('Ressecagem').value,
        secagem_frio: element.instance.formulario?.get('secagem_frio').value,
        umidade_media: element.instance.formulario?.get('umidade_media').value,
      })
    })

    this.formulario?.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    this.formulario?.get('list_secagem').setValue(secagemList);
  }

  // FIM DO CODIGO DE CALCULO

  // INICIO DAS REGRAS DE NEGOCIO SDC DESPALHA

  private buildListSdcDespalha(): void {
    const sdcDescarga: SdcDescargaItem[] = [];
    this.cardSdcComponent.componentsReferences.forEach(x => {
      sdcDescarga.push({
        id: x.instance.formulario.get('id')?.value,
        cd_cerar: x.instance.formulario.get('cd_cerar')?.value,
        cd_contrato: x.instance.formulario.get('cd_contrato')?.value,
        qt_rw_kg: x.instance.formulario.get('qt_rw_kg')?.value,
        // qt_porcentagem_umidade_direcionamento: x.instance.formulario.get('qt_porcentagem_umidade_direcionamento')?.value,
        qt_umidade_cerar: x.instance.formulario.get('qt_umidade_cerar')?.value,
        qt_porcentagem_descarregado: x.instance.formulario.get('qt_porcentagem_descarregado')?.value,
        qt_temperatura_maxima_do_tempo_total_de_transporte: x.instance.formulario.get('qt_temperatura_maxima_do_tempo_total_de_transporte')?.value,
        cd_lote_rw: x.instance.formulario.get('cd_lote_rw').value
        // qt_porcentagem_granacao: x.instance.formulario.get('qt_porcentagem_granacao')?.value
      })
    });

    // TODO: Se a lista for vazia, os campos calculados se tornarao vazios tambem
    this.formulario.get('controle_secagem').setValue(this.cardSdcComponent.formulario.get('controle_secagem').value);
    this.formulario.get('secador_camara').setValue(this.cardSdcComponent.formulario.get('secador_camara').value);
    this.formulario.get('list_sdc').setValue(sdcDescarga);
  }

  public createSecagemCardIItemCompoment(data: any): void {
    if (!!data.formulario?.list_secagem) {
      const totalItens: number = data.formulario.list_secagem?.length;

      for (let j = 0; j < totalItens; j++) {
        this.sec002CardIIComponent.createSecagemItemComponent();
      }

      if (this.sec002CardIIComponent.VCR.length < 1) return;

      for (let key = 0; key < totalItens; key++) {
        let componentRef = this.sec002CardIIComponent.secagemItemReferences.filter(x => x.instance.unique_key == key)[0];
        componentRef.instance.formulario.get('id').setValue(data.formulario.list_secagem[key].id);
        componentRef.instance.formulario.get('amostragem_data_inicio').setValue(data.formulario.list_secagem[key].amostragem_data_inicio);
        componentRef.instance.formulario.get('amostragem_hora_inicio').setValue(data.formulario.list_secagem[key].amostragem_hora_inicio);
        componentRef.instance.formulario.get('amostragem_data_fim').setValue(data.formulario.list_secagem[key].amostragem_data_fim);
        componentRef.instance.formulario.get('amostragem_hora_fim').setValue(data.formulario.list_secagem[key].amostragem_hora_fim);
        componentRef.instance.formulario.get('amostra_1_umidade').setValue(data.formulario.list_secagem[key].amostra_1_umidade);
        componentRef.instance.formulario.get('amostra_2_umidade').setValue(data.formulario.list_secagem[key].amostra_2_umidade);
        componentRef.instance.formulario.get('amostra_3_umidade').setValue(data.formulario.list_secagem[key].amostra_3_umidade);
        componentRef.instance.formulario.get('umidade_media').setValue(data.formulario.list_secagem[key].umidade_media);
        componentRef.instance.formulario.get('andar_secador').setValue(data.formulario.list_secagem[key].andar_secador);
        componentRef.instance.formulario.get('numero_secador').setValue(data.formulario.list_secagem[key].numero_secador);
        componentRef.instance.formulario.get('numero_dumper').setValue(data.formulario.list_secagem[key].numero_dumper);
        componentRef.instance.formulario.get('secagem_frio').setValue(data.formulario.list_secagem[key].secagem_frio);
        componentRef.instance.formulario.get('finalizou_secagem_caixa').setValue(data.formulario.list_secagem[key].finalizou_secagem_caixa);
        componentRef.instance.formulario.get('Ressecagem').setValue(data.formulario.list_secagem[key].ressecagem);
        componentRef.instance.formulario.get('peso_pos_secagem').setValue(data.formulario.list_secagem[key].peso_pos_secagem);

      }
    }
  }

  public createSdcCardItemComponent(data: any): void {

    this.cardSdcComponent.formulario.get('controle_secagem').setValue(data.formulario.controle_secagem);
    this.cardSdcComponent.formulario.get('secador_camara').setValue(data.formulario.secador_camara);

    if (!!data.formulario?.list_sdc) {
      const totalItens: number = data.formulario.list_sdc?.length > 0 ? data.formulario.list_sdc?.length >
        this.cardSdcComponent.maxItensOnList ? this.cardSdcComponent.maxItensOnList : data.formulario.list_sdc?.length : this.cardSdcComponent.minItensOnList;

      for (let j = 0; j < totalItens; j++) {
        this.cardSdcComponent.createSdcDescargaItemComponent();
      }

      if (this.cardSdcComponent.VCR.length < 1) return;

      for (let key = 0; key < totalItens; key++) {
        let componentRef = this.cardSdcComponent.componentsReferences.filter(x => x.instance.unique_key == key)[0];
        componentRef.instance.formulario.get('id').setValue(data.formulario.list_sdc[key].id);
        componentRef.instance.formulario.get('cd_cerar').setValue(data.formulario.list_sdc[key].cd_cerar);
        componentRef.instance.readonlyCerar = true;
        componentRef.instance.disableBtn = true;
        componentRef.instance.btnExcluir = true;

        componentRef.instance.formulario.get('cd_contrato').setValue(data.formulario.list_sdc[key].cd_contrato);
        componentRef.instance.formulario.get('qt_rw_kg').setValue(data.formulario.list_sdc[key].qt_rw_kg);
        // componentRef.instance.formulario.get('qt_porcentagem_umidade_direcionamento').setValue(data.formulario.list_sdc[key].qt_porcentagem_umidade_direcionamento);
        componentRef.instance.formulario.get('qt_umidade_cerar').setValue(data.formulario.list_sdc[key].qt_umidade_cerar);
        componentRef.instance.formulario.get('qt_porcentagem_descarregado').setValue(data.formulario.list_sdc[key].qt_porcentagem_descarregado);
        componentRef.instance.formulario.get('qt_temperatura_maxima_do_tempo_total_de_transporte').setValue(data.formulario.list_sdc[key].qt_temperatura_maxima_do_tempo_total_de_transporte);
        componentRef.instance.formulario.get('cd_lote_rw').setValue(data.formulario.list_sdc[key].cd_lote_rw);
        // componentRef.instance.formulario.get('qt_porcentagem_granacao').setValue(data.formulario.list_sdc[key].qt_porcentagem_granacao);
      }
    }
  }

  public async makeCalcSdc(event?: any): Promise<void> {
    await Promise.all([this.calcSdcPesoRw(), this.calcGetQua007DataToSec002(), this.calcMediaUmidade()])
  }

  private calcSdcPesoRw(): void {
    const totalItens: number = this.cardSdcComponent?.componentsReferences?.length as number ?? 0;
    let pesoTotalRw: number = 0;
    for (let key = 0; key < totalItens; key++) {
      let componentRef = this.cardSdcComponent.componentsReferences.filter(x => x.instance.unique_key == key)[0];
      const qtPorcDescarregado: number = (componentRef.instance.formulario.get('qt_porcentagem_descarregado').value);
      const qtRwKg: number = (componentRef.instance.formulario.get('qt_rw_kg').value);
      pesoTotalRw += this.generalService.CalcMultAndDiv(qtPorcDescarregado, qtRwKg);
    }
    this.sec002CardIComponent.formulario.get('Peso_rw_kg_total').setValue(pesoTotalRw);
  }

  private calcMediaUmidade(): void {
    const totalItens: number = (this.cardSdcComponent?.componentsReferences?.length as number ?? 0);

    let mediaUmidade: number = 0;
    let somarMedia: number = 0;
    let qt_rw_kg_total: number = 0;
    for (let key = 0; key < totalItens; key++) {
      let componentRef = this.cardSdcComponent.componentsReferences.filter(x => x.instance.unique_key == key)[0];
      let qt_rw_kg = (componentRef.instance.formulario.get('qt_rw_kg').value);
      let qt_umidade_cerar = ((componentRef.instance.formulario.get('qt_umidade_cerar').value));
      let qt_porcentagem_descarregado = ((componentRef.instance.formulario.get('qt_porcentagem_descarregado').value / 100));
      somarMedia = somarMedia + (qt_umidade_cerar * (qt_rw_kg * qt_porcentagem_descarregado));
      qt_rw_kg_total = qt_rw_kg_total + (qt_porcentagem_descarregado * qt_rw_kg);
    }
    mediaUmidade = (somarMedia / qt_rw_kg_total);
    this.sec002CardIComponent.formulario.get('Umidade_media_cerar').setValue(!isNaN(mediaUmidade) ? mediaUmidade : null);
  }

  private async calcGetQua007DataToSec002(): Promise<void> {

    const site = localStorage.getItem('data_site');
    const safra = this.sec002CardIComponent.formulario.get('Safra')?.value as string ?? '';
    const hibrido = this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem')?.value as string ?? '';
    const totalItens: number = this.cardSdcComponent?.componentsReferences?.length as number ?? 0;
    //let faixa_azul_umidade: string = '';
    this.disablesave = false;
    const arrFaixaAzulUmidade: string[] = [];
    const arrFaixaAzulCampo: string[] = [];
    const arrFaixaAzulTransbordo: string[] = [];
    const arrFaixaAzulClaroTemperatura: string[] = [];
    const arrFaixaAzulEscuroTemperatura: string[] = [];
    const arrFaixaAzulClaroTempo: string[] = [];
    const arrFaixaAzulEscuroTempo: string[] = [];
    const arrFaixaAzulEscuroGranelTempo: string[] = [];
    if (totalItens < 1) { return; }
    const arrContrato: string[] = [];
    for (let key = 0; key < totalItens; key++) {
      let componentRef = this.cardSdcComponent.componentsReferences.filter(x => x.instance.unique_key == key)[0];
      const cerar: string = componentRef.instance.formulario.get('cd_cerar')?.value as string ?? '0';

      if (cerar.length == 1 || cerar.length == 0) {


        this.disablesave = true;
      }
      if (!!cerar) {
        await this.formularioService.calcGetQua007DataToSec002(cerar).pipe(take(1)).toPromise().then(async (response: any) => {
          if (!!response?.data) {
            this.sec002CardIComponent.formulario.get('Tipo_colheita').setValue(response?.data?.tipo_colheita);
            if (!arrContrato.includes(response?.data?.contrato_juridico)) {
              arrContrato.push(response?.data?.contrato_juridico.toUpperCase());
            }
            const siteRecebimentoResp = response?.data?.site_recebimento;
            const safraResponse = response?.data?.safra;

            const hibridoResponse = response?.data?.hibrido_rnc;

            if (siteRecebimentoResp.length > 0 && site.length > 0 && siteRecebimentoResp !== site) {

              this.disablesave = true;

              this.sec002CardIComponent.formulario.get('Site_recebimento').setValue(response?.data?.site_recebimento);
              this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
              this.sec002CardIComponent.formulario.get('Safra').setValue(response?.data?.safra);
              this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem').setValue(response?.data?.hibrido_rnc);

              this.notificationService.showNotification(`Verificar os Cerars Informados. Eles não podem ser de site de recebimento  diferentes.`);
              return;
            } else if (safra.length > 0 && safraResponse.length > 0 && safraResponse !== safra) {
              this.disablesave = true;
              this.sec002CardIComponent.formulario.get('Site_recebimento').setValue(response?.data?.site_recebimento);
              this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
              this.sec002CardIComponent.formulario.get('Safra').setValue(response?.data?.safra);
              this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem').setValue(response?.data?.hibrido_rnc);

              this.notificationService.showNotification(`Verificar os Cerars Informados. Eles não podem ser de safra diferentes.`);

            } else if (hibridoResponse.length > 0 && hibrido.length > 0 && hibridoResponse !== hibrido) {
              this.disablesave = true;

              this.sec002CardIComponent.formulario.get('Site_recebimento').setValue(response?.data?.site_recebimento);
              this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
              this.sec002CardIComponent.formulario.get('Safra').setValue(response?.data?.safra);
              this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem').setValue(response?.data?.hibrido_rnc);


              this.notificationService.showNotification(`Verificar os Cerars Informados. Eles não podem ser de hibrido diferentes.`);


            }
            else {
              if (siteRecebimentoResp.length > 0 && site.length > 0 && siteRecebimentoResp == site) {
                this.disablesave = false;
                this.sec002CardIComponent.formulario.get('Site_recebimento').setValue(response?.data?.site_recebimento);
                this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
                this.sec002CardIComponent.formulario.get('Safra').setValue(response?.data?.safra);
                this.sec002CardIComponent.formulario.get('Hibrido_rnc_linhagem').setValue(response?.data?.hibrido_rnc);
              }
            }



            //this.sec002CardIComponent.formulario.get('Contrato_campo').setValue(response?.data?.contrato_juridico);
            //this.sec002CardIComponent.formulario.get('Contrato_campo_2').setValue(componentRef.instance.formulario.get('cd_contrato').value);

            this.sec002CardIComponent.formulario.get('Geracao').setValue(response?.data?.geracao);
            this.sec002CardIComponent.formulario.get('Especie').setValue(response?.data?.especie);
            this.sec002CardIComponent.formulario.get('Site_origem').setValue(response?.data?.site_origem);
            this.sec002CardIComponent.formulario.get('Num_campo').setValue(response?.data?.numero_campo);
            // if (!response?.data?.faixa_azul_campo?.includes('SEM FAIXA AZUL')) {
            //     this.sec002CardVIIComponent.formulario.get('Faixa_azul_campo').setValue(response?.data?.faixa_azul_campo);
            // }
            if ((!arrFaixaAzulCampo.includes(response?.data?.faixa_azul_campo)) && (response?.data?.faixa_azul_campo !== 'SEM FAIXA AZUL')) {
              var faixa_azul_campo = response?.data?.faixa_azul_campo.split(',') as [];
              arrFaixaAzulCampo.push(...faixa_azul_campo);

            }
            if (!arrFaixaAzulUmidade.includes(response?.data?.faixa_azul_umidade)) {
              arrFaixaAzulUmidade.push(response?.data?.faixa_azul_umidade);
            }
            if (!arrFaixaAzulTransbordo.includes(response?.data.faixa_azul_transbordo)) {
              arrFaixaAzulTransbordo.push(response?.data.faixa_azul_transbordo)
            }


            if (Number(response?.data?.temperatura_maxima_tempo) >= 40 && Number(response?.data?.temperatura_maxima_tempo) <= 45 && response?.data?.tipo_colheita != 'GRANEL') {
              arrFaixaAzulClaroTemperatura.push('SIM')
            }
            else if (Number(response?.data?.temperatura_maxima_tempo) > 45 && response?.data?.tipo_colheita != 'GRANEL') {
              arrFaixaAzulEscuroTemperatura.push('SIM')
            }

            if ((Number(response?.data?.temperatura_maxima_tempo) == 0 || response?.data?.temperatura_maxima_tempo == null) && Number(response?.data?.tempo_espera_patio) > 12 && Number(response?.data?.tempo_espera_patio) <= 18) {
              arrFaixaAzulClaroTempo.push('SIM')
            }
            else if ((Number(response?.data?.temperatura_maxima_tempo) == 0 || response?.data?.temperatura_maxima_tempo == null) && Number(response?.data?.tempo_espera_patio) > 18) {
              arrFaixaAzulEscuroTempo.push('SIM')
            }

            if ((Number(response?.data?.temperatura_maxima_tempo) == 0 || response?.data?.temperatura_maxima_tempo == null) && Number(response?.data?.tempo_total_transporte) > 14 && response?.data?.tipo_colheita == 'GRANEL') {
              arrFaixaAzulEscuroGranelTempo.push('SIM')
            }

            // if (!response?.data?.faixa_azul_umidade?.includes('SIM')) {
            //     faixa_azul_umidade = 'SIM'
            //     //this.sec002CardVIIComponent.formulario.get('Faixa_azul_umidade_de_colheita').setValue(response?.data?.faixa_azul_umidade);
            // }
          }
        }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes a combinação do cerar ${cerar}. Entre em contato com o Administrador.`);
        });
      }
    }
    if (arrFaixaAzulUmidade.includes('SIM')) {
      this.sec002CardVIIComponent.formulario.get('Faixa_azul_umidade_de_colheita').setValue('SIM');
    } else {
      this.sec002CardVIIComponent.formulario.get('Faixa_azul_umidade_de_colheita').setValue('NÃO');
    }
    if (arrFaixaAzulCampo.length >= 1) {
      let newArrFaixaAzulCampo = arrFaixaAzulCampo.filter((value, index, self) => {
        return self.indexOf(value) === index
      });
      this.sec002CardVIIComponent.formulario.get('Faixa_azul_campo').setValue(newArrFaixaAzulCampo.join(';').trim());
    } else {
      this.sec002CardVIIComponent.formulario.get('Faixa_azul_campo').setValue('SEM FAIXA AZUL');
    }
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_transbordo').setValue(arrFaixaAzulTransbordo.includes('SIM') ? 'SIM' : 'NÃO')
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_claro_temperatura_carga').setValue(arrFaixaAzulClaroTemperatura.includes('SIM') ? 'SIM' : 'NÃO')
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_temperatura_carga').setValue(arrFaixaAzulEscuroTemperatura.includes('SIM') ? 'SIM' : 'NÃO')
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_claro_tempo_de_patio').setValue(arrFaixaAzulClaroTempo.includes('SIM') ? 'SIM' : 'NÃO')
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_tempo_de_patio').setValue(arrFaixaAzulEscuroTempo.includes('SIM') ? 'SIM' : 'NÃO')
    this.sec002CardVIIComponent.formulario.get('Faixa_azul_escuro_granel_tempo_de_transporte').setValue(arrFaixaAzulEscuroGranelTempo.includes('SIM') ? 'SIM' : 'NÃO')

    if (arrContrato.length === 1) {
      this.sec002CardIComponent.formulario.get('Contrato_campo').setValue(arrContrato[0]);
      // this.sec002CardIComponent.formulario.get('Contrato_campo_2').setValue(arrContrato[0]);
    } else if (arrContrato.length > 1) {
      this.sec002CardIComponent.formulario.get('Contrato_campo').setValue(arrContrato.filter((item,
        index) => arrContrato.indexOf(item) === index).join(';'));
      // this.sec002CardIComponent.formulario.get('Contrato_campo_2').setValue(arrContrato[1]);
    }

  }
  // FIM DAS REGRAS DE NEGOCIO SDC DESPALHA

  addStore = (itemValue: string = null) => {
    if (itemValue !== null) {

      const clone = {
        form: itemValue
      };

      this.add.dispatch(Add(clone.form));

    }
  }

  reqSecagem = () => {
    const values = this.sec002CardIIIComponent.formulario.getRawValue()

    const terminoSecagemData = this.sec002CardIIComponent.formulario.get("Termino_secagem_data")?.value
    const terminoSecagemHora = this.sec002CardIIComponent.formulario.get("Termino_secagem_hora")?.value

    if (Object.keys(values).filter(value => values[value] != null && values[value] != "").length > 0) {
      if (terminoSecagemData == null || terminoSecagemHora == null) {
        this.notificationService.sendNotification("Termino da secagem precisa ser preenchido", TypeMessage.Personalized, ActionMessage.Warning)

        this.sec002CardIIComponent.formulario.get("Termino_secagem_data").setValidators([Validators.required, Validators.pattern(this.regexDate)]);
        this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").setValidators([Validators.required, Validators.pattern(this.regexHour)]);
        this.sec002CardIIComponent.formulario.get("Termino_secagem_data").setErrors({ required: true });
        this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").setErrors({ required: true });
        this.sec002CardIIComponent.formulario.get("Termino_secagem_data").updateValueAndValidity();
        this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").updateValueAndValidity();
        this.sec002CardIIComponent.formulario.get("Termino_secagem_data").markAsTouched();
        this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").markAsTouched()

      }
    }
    else {
      this.sec002CardIIComponent.formulario.get("Termino_secagem_data").setValidators([Validators.pattern(this.regexDate)]);
      this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").setValidators([Validators.pattern(this.regexHour)]);
      this.sec002CardIIComponent.formulario.get("Termino_secagem_data").setErrors({ required: false });
      this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").setErrors({ required: false });
      this.sec002CardIIComponent.formulario.get("Termino_secagem_data").updateValueAndValidity();
      this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").updateValueAndValidity();
      this.sec002CardIIComponent.formulario.get("Termino_secagem_data").markAsTouched();
      this.sec002CardIIComponent.formulario.get("Termino_secagem_hora").markAsTouched()
    }
  }

  private getUser(): void {
    this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
      this.fillCreatedByFormField();
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.currentUser = response ?? 'Administrador';
        this.fillCreatedByFormField();
      }).catch(err => {
      });
    });
  }

  private fillCreatedByFormField(): void {
    this.sec002CardXComponent.formulario.get('criado_por').setValue(this.currentUser);
  }
  calcUmidadeMediaSecagem() {
    const nota = this.sec002CardIComponent.formulario.get('nota_ardida')?.value
    this.sec002CardIIComponent.secagemItemReferences.forEach(item => {
      if ((nota == 'A' || nota == 'B') && item.instance.formulario?.get("umidade_media").value <= 12.5) {
        item.instance.formulario?.get("finalizou_secagem_caixa").setValue("Sim");
      }
      else if ((nota == 'C' || nota == 'D') && item.instance.formulario?.get("umidade_media").value <= 13.5) {
        item.instance.formulario?.get("finalizou_secagem_caixa").setValue("Sim");
      } else {
        item.instance.formulario?.get("finalizou_secagem_caixa").setValue("Não");
      }



    })


  }

  getRessect(isRessectSelected: boolean) {
    this.isRessectSelected = isRessectSelected;
  }
  makeCalcPrebasica($event) {
    this.calcUmidadeMediaSecagem()
  }
}

